import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b03e9fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-update-record" }
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_page, { fheader: { showCollapse: true } }, {
      fheader: _withCtx(({ collapse }) => [
        _createVNode(_component_el_form, {
          size: "default",
          ref: "queryForm",
          "label-width": "120px",
          model: _ctx.params,
          onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "系统类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择系统类型",
                  modelValue: _ctx.params.appPlatform,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.appPlatform) = $event)),
                  style: {"width":"100%"},
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APP_SYSTEM_TYPE_LIST, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "应用名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请输入应用名称",
                  modelValue: _ctx.params.appName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.appName) = $event)),
                  style: {"width":"100%"},
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.appCode,
                        label: item.appName,
                        value: item.appName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "更新级别"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择更新级别",
                      modelValue: _ctx.params.updateLevel,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.updateLevel) = $event)),
                      style: {"width":"100%"},
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APP_UPDATE_LEVEL_LIST, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "版本号"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入版本号",
                      modelValue: _ctx.params.versionNum,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.versionNum) = $event)),
                      modelModifiers: { trim: true },
                      maxlength: "200",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "操作人"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入操作人",
                      modelValue: _ctx.params.creatorName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.creatorName) = $event)),
                      modelModifiers: { trim: true },
                      maxlength: "200",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              "label-width": "0",
              class: "margin-left-20"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "default",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSearch())),
                  onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查询 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "default",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleReset()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 重置 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["model"])
      ]),
      main: _withCtx(({
          height
        }) => [
        (_openBlock(), _createBlock(_component_el_table, {
          height: height,
          key: height,
          data: _ctx.tableData,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "appName",
              label: "应用名称",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              width: "80",
              prop: "appPlatform",
              label: "系统类型",
              align: "center"
            }, {
              default: _withCtx(({ row: { appPlatform } }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.APP_SYSTEM_TYPE_LIST, appPlatform)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              width: "100",
              prop: "versionNum",
              label: "版本号",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              width: "100",
              prop: "updateLevel",
              label: "更新级别",
              align: "center"
            }, {
              default: _withCtx(({ row: { updateLevel } }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.APP_UPDATE_LEVEL_LIST, updateLevel)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "deptNames",
              label: "更新部门",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                  content: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.deptNames), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "dept-names",
                      textContent: _toDisplayString(row.deptNames)
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "specifyVersion",
              label: "指定版本",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "updateLog",
              label: "更新概述",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "noticeTime",
              label: "创建信息",
              align: "center"
            }, {
              default: _withCtx(({ row: { creatorName, createdTime } }) => [
                _createTextVNode(_toDisplayString(creatorName) + " ", 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatTime(createdTime)), 1)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["height", "data"]))
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["total", "current-page", "size", "onSizeChange", "onCurrentChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}